/* import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "./ui/table";
import { useState, useEffect } from "react";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation } from "react-router-dom";

export default function SalesRepPerformancePanel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRep, setSelectedRep] = useState(null);
  const [selectedCityReps, setSelectedCityReps] = useState([]);
  const [chosenRepId, setChosenRepId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
     const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const [filters, setFilters] = useState({
    city: "",
    performanceStatus: "",
  });
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("city");
  const [salesRepsData, setSalesRepsData] = useState([
  { id: 1, name: "Amit Sharma", mobileNumber: "9876543210", city: "Mumbai", callsInitiated: 120, avgResponseSpeedHrs: 2.3, followUpRate: "85%", rfqResponseSpeedHrs: 1.8, conversionRate: "15%", performanceStatus: "Good" },
  { id: 2, name: "Neha Patel", mobileNumber: "9876501234", city: "Delhi", callsInitiated: 98, avgResponseSpeedHrs: 3.1, followUpRate: "78%", rfqResponseSpeedHrs: 2.5, conversionRate: "12%", performanceStatus: "Average" },
  { id: 3, name: "Ravi Kumar", mobileNumber: "9876567890", city: "Bengaluru", callsInitiated: 134, avgResponseSpeedHrs: 1.7, followUpRate: "90%", rfqResponseSpeedHrs: 1.2, conversionRate: "18%", performanceStatus: "Excellent" },
  { id: 4, name: "Sunil Verma", mobileNumber: "9876511122", city: "Mumbai", callsInitiated: 110, avgResponseSpeedHrs: 2.1, followUpRate: "82%", rfqResponseSpeedHrs: 1.6, conversionRate: "14%", performanceStatus: "Good" },
  { id: 5, name: "Priya Nair", mobileNumber: "9876533344", city: "Delhi", callsInitiated: 105, avgResponseSpeedHrs: 3.0, followUpRate: "80%", rfqResponseSpeedHrs: 2.3, conversionRate: "13%", performanceStatus: "Good" },
]);
  const isSalesRepPage = location.pathname.includes("/manufacturer/app/salesrep");

  const statusColorMap = {
    Excellent: "bg-gradient-to-r from-emerald-500 to-green-400 text-white shadow-sm",
    Good: "bg-gradient-to-r from-blue-500 to-sky-400 text-white shadow-sm",
    Average: "bg-gradient-to-r from-amber-500 to-yellow-400 text-white shadow-sm",
    Poor: "bg-gradient-to-r from-rose-500 to-red-400 text-white shadow-sm",
  };

  useEffect(() => {
  fetchSalesRepsPerformanceList();
}, []);


  function openEditModal(rep) {
    setSelectedRep(rep);
    const repsInCity = salesRepsData.filter(r => r.city === rep.city);
    setSelectedCityReps(repsInCity);
    setChosenRepId(rep.id);
  }

  function closeModal() {
    setSelectedRep(null);
    setSelectedCityReps([]);
    setChosenRepId(null);
  }

  const handleNavigate = () => () => {
    navigate("/manufacturer/app/salesrep");
  };

  const handleClearAll = () => {
    setFilters({ city: "", performanceStatus: "" });
    setSearchQuery("");
  };

  function openEditModal(rep) {
  setSelectedRep({ ...rep }); // clone to avoid direct mutation
  setChosenRepId(rep.id);
}


  const filteredData = salesRepsData.filter((rep) => {
    const matchesSearch = Object.values(rep)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesCity = filters.city ? rep.city === filters.city : true;
    const matchesPerformance = filters.performanceStatus
      ? rep.performanceStatus === filters.performanceStatus
      : true;

    return matchesSearch && matchesCity && matchesPerformance;
  });

  const chosenRep = selectedCityReps.find(r => r.id === chosenRepId);
  const activeFilters = Object.entries(filters).filter(([_, value]) => value);



const fetchSalesRepsPerformanceList = async () => {
  try {
    const manufacturerId = "678e1bdf3ce3c1c267977a1e"; 
    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}manufacturer/get-all-salesreps-performance-list?vendor_id=${manufacturerId}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Sales Reps Performance Data:", data);

    if (response.ok && data.salesReps) {
      // 🔑 map API response into UI-compatible structure
      const mappedData = data.salesReps.map(rep => ({
        id: rep.salesRepId,
        name: rep.name,
        mobileNumber: rep.mobile,   // API field → UI field
        city: rep.city,
        callsInitiated: rep.metrics.callsInitiated,
        avgResponseSpeedHrs: parseFloat(rep.metrics.avgResponseSpeedHrs),
        followUpRate: rep.metrics.followUpRate,
        rfqResponseSpeedHrs: parseFloat(rep.metrics.avgRFQResponseSpeedHrs),
        conversionRate: rep.metrics.conversionRate,
        performanceStatus: rep.performance.status,
      }));

      setSalesRepsData(mappedData);
    } else {
      console.error("Failed to fetch sales reps performance list:", data.message);
    }
  } catch (error) {
    console.error("Error in fetchSalesRepsPerformanceList:", error);
  }
};




  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white px-4 pb-3 pt-4 shadow-md dark:border-gray-800 dark:bg-gray-900 sm:px-6">
      <div className="flex flex-col gap-2 mb-4 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white">
          Sales Rep Performance
        </h3>
        <div className="flex items-center gap-3">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-1 rounded-lg text-sm dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            onClick={() => setShowFilterModal(true)}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
          >
            Filter
          </button>
          {!isSalesRepPage && (
            <button
              onClick={handleNavigate()}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
            >
              See all
            </button>
          )}
        </div>
      </div>

      {(activeFilters.length > 0 || searchQuery) && (
        <div className="flex flex-wrap items-center gap-2 mb-3">
          {searchQuery && (
            <span className="flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-xs">
              Search: {searchQuery}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setSearchQuery("")}
              />
            </span>
          )}
          {activeFilters.map(([key, value]) => (
            <span
              key={key}
              className="flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs"
            >
              {key}: {value}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setFilters((f) => ({ ...f, [key]: "" }))}
              />
            </span>
          ))}
          <button
            onClick={handleClearAll}
            className="text-xs px-3 py-1 bg-red-100 text-red-700 rounded-full hover:bg-red-200"
          >
            Clear All
          </button>
          <span className="ml-auto text-xs text-gray-500">
            {filteredData.length} results
          </span>
        </div>
      )}

      <div className="max-w-full overflow-x-auto">
        <Table>
          <TableHeader className="border-gray-100 dark:border-gray-800 border-y bg-gray-50/50 dark:bg-gray-800/50">
            <TableRow>
              {["Sales Rep", "City", "Mobile Number","Calls Initiated", "Avg Response Speed (hrs)", "Follow-up Rate", "RFQ Response Speed (hrs)", "Conversion Rate", "Performance", "Actions"].map((header) => (
                <TableCell
                  key={header}
                  isHeader
                  className="py-3 font-medium text-gray-600 text-center text-xs uppercase tracking-wide dark:text-gray-400"
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody className="divide-y divide-gray-100 dark:divide-gray-800">
            {filteredData.map((rep) => (
              <TableRow
                key={rep.id}
                className="hover:bg-gray-50 dark:hover:bg-gray-800/70 transition-colors duration-200"
              >
                <TableCell className="py-3 text-gray-800 font-medium dark:text-gray-200">{rep.name}</TableCell>
                <TableCell className="py-3 text-gray-600 dark:text-gray-400">{rep.city}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.mobileNumber}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.callsInitiated}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.avgResponseSpeedHrs.toFixed(1)}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.followUpRate}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.rfqResponseSpeedHrs.toFixed(1)}</TableCell>
                <TableCell className="py-3 text-center text-gray-700 dark:text-gray-300">{rep.conversionRate}</TableCell>
                <TableCell className="py-3 text-center">
                  <span
                    className={`px-3 py-1.5 text-xs font-semibold rounded-full ${statusColorMap[rep.performanceStatus] || "bg-gray-300 text-gray-800"}`}
                  >
                    {rep.performanceStatus}
                  </span>
                </TableCell>
                <TableCell className="py-3 text-center">
                  <button
                    onClick={() => openEditModal(rep)}
                    className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 transition"
                    title="Edit"
                  >
                    <PencilIcon className="h-5 w-5 text-gray-700 dark:text-gray-300" />
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {showFilterModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
          <div className="bg-white/90 dark:bg-gray-900/90 p-6 rounded-2xl shadow-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 relative flex">
            <XMarkIcon
              className="w-6 h-6 absolute top-4 right-4 cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={() => setShowFilterModal(false)}
            />

            <div className="w-1/3 border-r dark:border-gray-700 pr-4">
              <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">
                Filter By
              </h2>
              <ul className="space-y-2">
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg transition ${
                    selectedFilterCategory === "city" ? "bg-blue-100 text-blue-700" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                  onClick={() => setSelectedFilterCategory("city")}
                >
                  City
                </li>
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg transition ${
                    selectedFilterCategory === "performanceStatus" ? "bg-blue-100 text-blue-700" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                  onClick={() => setSelectedFilterCategory("performanceStatus")}
                >
                  Performance
                </li>
              </ul>
            </div>

            <div className="w-2/3 pl-4 animate-fadeIn">
              <h3 className="text-md font-semibold mb-4 text-gray-700 dark:text-gray-300">
                {selectedFilterCategory === "city" ? "Select City" : "Select Performance"}
              </h3>
              <ul className="space-y-2">
                <li
                  className={`cursor-pointer px-3 py-2 rounded-lg ${
                    !filters[selectedFilterCategory] ? "bg-blue-500 text-white" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                  onClick={() => {
                    setFilters((f) => ({ ...f, [selectedFilterCategory]: "" }));
                    setShowFilterModal(false);
                  }}
                >
                  All
                </li>
                {selectedFilterCategory === "city"
                  ? [...new Set(salesRepsData.map((r) => r.city))].map((city) => (
                      <li
                        key={city}
                        className={`cursor-pointer px-3 py-2 rounded-lg ${
                          filters.city === city ? "bg-blue-500 text-white" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                        }`}
                        onClick={() => {
                          setFilters((f) => ({ ...f, city }));
                          setShowFilterModal(false);
                        }}
                      >
                        {city}
                      </li>
                    ))
                  : [...new Set(salesRepsData.map((r) => r.performanceStatus))].map((status) => (
                      <li
                        key={status}
                        className={`cursor-pointer px-3 py-2 rounded-lg ${
                          filters.performanceStatus === status ? "bg-blue-500 text-white" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                        }`}
                        onClick={() => {
                          setFilters((f) => ({ ...f, performanceStatus: status }));
                          setShowFilterModal(false);
                        }}
                      >
                        {status}
                      </li>
                    ))}
              </ul>
            </div>
          </div>
        </div>
      )}


{selectedRep && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
    <div className="bg-white/95 dark:bg-gray-900/95 p-6 rounded-2xl shadow-2xl w-full max-w-md border border-gray-200 dark:border-gray-700">
      <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">
        Edit Sales Rep Details
      </h2>

      <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
        Name
      </label>
      <input
        type="text"
        value={selectedRep.name}
        onChange={(e) =>
          setSelectedRep({ ...selectedRep, name: e.target.value })
        }
        className="w-full border rounded-lg px-3 py-2 mb-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
      />

      <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
        Mobile Number
      </label>
      <input
        type="text"
        value={selectedRep.mobileNumber || ""}
        onChange={(e) =>
          setSelectedRep({ ...selectedRep, mobileNumber: e.target.value })
        }
        className="w-full border rounded-lg px-3 py-2 mb-4 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
      />

      <div className="flex justify-end gap-3">
        <button
          onClick={closeModal}
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 transition"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            setSalesRepsData(prev =>
              prev.map(r => (r.id === selectedRep.id ? selectedRep : r))
            );
            closeModal();
          }}
          className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition"
        >
          Save
        </button>

      </div>
    </div>
  </div>
)}

    </div>
  );
}
 */


import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "./ui/table";
import { useState, useEffect } from "react";
import { PencilIcon, XMarkIcon, PlusIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation } from "react-router-dom";

export default function SalesRepPerformancePanel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedRep, setSelectedRep] = useState(null);
  const [selectedCityReps, setSelectedCityReps] = useState([]);
  const [chosenRepId, setChosenRepId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  const [filters, setFilters] = useState({
    city: "",
    performanceStatus: "",
  });
  const [selectedFilterCategory, setSelectedFilterCategory] =
    useState("city");
  const [salesRepsData, setSalesRepsData] = useState([]);



  
  const [newRep, setNewRep] = useState({
  name: "",
  mobile: "",
  email: "",
  city: "",
  state: "",
  region: "",
  vendor_id: sessionStorage.getItem("userId") || "", // ✅ dynamic from sessionStorage
  performanceRating: 0,
  performanceStatus: "Pending",
});

  const isSalesRepPage =
    location.pathname.includes("/mfr/app/salesrep");

  const statusColorMap = {
    Excellent:
      "bg-gradient-to-r from-emerald-500 to-green-400 text-white shadow-sm",
    Good: "bg-gradient-to-r from-blue-500 to-sky-400 text-white shadow-sm",
    Average:
      "bg-gradient-to-r from-amber-500 to-yellow-400 text-white shadow-sm",
    Poor: "bg-gradient-to-r from-rose-500 to-red-400 text-white shadow-sm",
    Pending: "bg-gray-400 text-white",
  };

  useEffect(() => {
    fetchSalesRepsPerformanceList();
  }, []);

const fetchSalesRepsPerformanceList = async () => {
  try {
    const manufacturerId = sessionStorage.getItem("userId");
    console.log("Manufacturer ID:", manufacturerId);

    // ✅ Correct URL (no /brickbucket here)
    const apiUrl = `${fetchUrl}manufacturer/get-all-salesreps-performance-list?vendor_id=${manufacturerId}`;
    console.log("Fetching URL:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Sales Reps Performance Data:", data);

    if (response.ok && data.salesReps) {
      const mappedData = data.salesReps.map((rep) => ({
        id: rep._id,
        name: rep.name,
        mobileNumber: rep.mobile,
        city: rep.city,
        callsInitiated: rep.metrics.callsInitiated,
        avgResponseSpeedHrs: parseFloat(rep.metrics.avgResponseSpeedHrs),
        followUpRate: rep.metrics.followUpRate,
        rfqResponseSpeedHrs: parseFloat(rep.metrics.avgRFQResponseSpeedHrs),
        conversionRate: rep.metrics.conversionRate,
        performanceStatus: rep.performance.status,
      }));

      setSalesRepsData(mappedData);
    } else {
      console.error(
        "Failed to fetch sales reps performance list:",
        data.message
      );
    }
  } catch (error) {
    console.error("Error in fetchSalesRepsPerformanceList:", error);
  }
};


  function openEditModal(rep) {
    setSelectedRep({ ...rep });
    setChosenRepId(rep.id);
  }

  function closeModal() {
    setSelectedRep(null);
    setSelectedCityReps([]);
    setChosenRepId(null);
  }

const handleNavigate = () => {
    navigate("/mfr/app/salesrep");
  };

  const handleClearAll = () => {
    setFilters({ city: "", performanceStatus: "" });
    setSearchQuery("");
  };

  const filteredData = salesRepsData?.filter((rep) => {
  const matchesSearch = Object.values(rep)
    .join(" ")
    .toLowerCase()
    .includes(searchQuery.toLowerCase());

  const matchesCity = filters.city ? rep.city === filters.city : true;
  const matchesPerformance = filters.performanceStatus
    ? rep.performanceStatus === filters.performanceStatus
    : true;

  return matchesSearch && matchesCity && matchesPerformance;
});

  const activeFilters = Object.entries(filters).filter(([_, value]) => value);


  // ✅ Save New Sales Rep
 const handleSaveNewRep = async () => {
  console.log("Saving new rep:", newRep);

  try {
    const apiUrl = `${fetchUrl}manufacturer/create-salesrep`;
    console.log("API URL:", apiUrl);
    console.log("Request body:", JSON.stringify(newRep));

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newRep),
    });

    console.log("Response status:", response.status);

    const data = await response.json();
    console.log("Create Response:", data);

    if (response.ok) {
      setSalesRepsData((prev) => [
        ...prev,
        {
       id: data._id,
name: data.name,
mobileNumber: data.mobile,
city: data.city,
callsInitiated: 0,
avgResponseSpeedHrs: 0,
followUpRate: "0%",
rfqResponseSpeedHrs: 0,
conversionRate: "0%",
performanceStatus: data.performanceStatus,
        },
      ]);

      setShowAddModal(false);

      setNewRep({
        name: "",
        mobile: "",
        email: "",
        city: "",
        state: "",
        region: "",
     vendor_id: sessionStorage.getItem("userId") || "",
        performanceRating: 0,
        performanceStatus: "Pending",
      });
    } else {
      console.error("Error saving SalesRep:", data.message);
    }
  } catch (error) {
    console.error("Error in handleSaveNewRep:", error);
  }
};


   // Edit rep
  const handleSave = async () => {
    if (!selectedRep.id) return;
    console.log("Saving rep:", selectedRep);
    try {
      const apiUrl = `${fetchUrl}manufacturer/update-salesrep?repId=${selectedRep.id}`;
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(selectedRep),
      });
      const data = await response.json();
      console.log("Update Response:", data);
      if (response.ok) {
        setSalesRepsData((prev) =>
          prev.map((rep) => (rep.id === selectedRep.id ? selectedRep : rep))
        );
        setSelectedRep(false);
      } else {
        console.error("Error updating SalesRep:", data.message);
      }
    } catch (error) {
      console.error("Error in handleSave:", error);
    }
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white px-4 pb-3 pt-4 bg-white sm:px-6">
      {/* Header */}
  <div className="flex flex-col gap-4 mb-4">
  {/* Heading - always on its own line */}
  <h3 className="text-xl font-semibold text-gray-800 text-[#000000] ">
    Sales Rep Performance
  </h3>

  {/* Search bar - on its own line */}
  <div>
    <input
      type="text"
      placeholder="Search..."
      className="w-full border px-3 py-2 rounded-lg text-sm bg-white border border-gray-300 text-gray-200 font-medium"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />
  </div>

  {/* Buttons - stacked on mobile, inline on larger screens */}
<div className="w-full flex justify-end">
  <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3 w-full sm:w-auto">

    {/* Filter Button */}
    <button
      onClick={() => setShowFilterModal(true)}
      className="w-full sm:w-auto inline-flex items-center justify-center gap-1 rounded-md 
                 border border-gray-300 bg-white px-2 py-1.5 text-xs font-medium 
                 text-gray-700 hover:bg-gray-50
                 transition"
    >
      Filter
    </button>

    {/* See All Button */}
    {!isSalesRepPage && (
      <button
        onClick={handleNavigate}
        className="w-full sm:w-auto inline-flex items-center justify-center gap-1 rounded-md 
                   border border-gray-300 bg-white px-2 py-1.5 text-xs font-medium 
                   text-gray-700 shadow-sm hover:bg-gray-50
                   transition"
      >
        See all
      </button>
    )}

    {/* Add Sales Rep Button */}
    <button
      onClick={() => setShowAddModal(true)}
      className="w-full sm:w-auto inline-flex items-center justify-center gap-1 rounded-md 
                 bg-green-600 px-2 py-1.5 text-xs font-medium text-white 
                 hover:bg-green-700 shadow-sm transition"
    >
      <PlusIcon className="h-3.5 w-3.5" />
      Add Sales Rep
    </button>
  </div>
</div>


</div>
 {(activeFilters.length > 0 || searchQuery) && (
      <div className="mb-3">
        <div className="flex items-center gap-2 overflow-x-auto whitespace-nowrap sm:flex-wrap sm:overflow-visible py-1">
          {searchQuery && (
            <span className="shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-xs">
              Search: {searchQuery}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setSearchQuery("")}
              />
            </span>
          )}

          {activeFilters.map(([key, value]) => (
            <span
              key={key}
              className="shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs"
            >
              {key}: {value}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setFilters((f) => ({ ...f, [key]: "" }))}
              />
            </span>
          ))}

          <button
            onClick={handleClearAll}
            className="shrink-0 text-xs px-3 py-1 bg-red-100 text-red-700 rounded-full hover:bg-red-200"
          >
            Clear All
          </button>

          <span className="ml-auto hidden sm:inline text-xs text-gray-500">
            {filteredData.length} results
          </span>
        </div>

        <div className="sm:hidden mt-1 text-right text-xs text-gray-500">
          {filteredData.length} results
        </div>
      </div>
    )}


      {/* Table */}
  <div className="w-full">
  {/* Table layout - visible on md and above */}
  <div className="hidden md:block w-full overflow-x-auto">
    <Table className="w-full border border-gray-300 ">
      <TableHeader className="border-b border-gray-300  bg-white ">
        <TableRow>
          {[
            "Sales Rep",
            "City",
            "Mobile Number",
            "Calls Initiated",
            "Avg Response Speed (hrs)",
            "Follow-up Rate",
            "RFQ Response Speed (hrs)",
            "Conversion Rate",
            "Performance",
            "Actions",
          ].map((header) => (
            <TableCell
              key={header}
              isHeader
              className="py-3 px-2 font-semibold text-gray-800 text-center text-xs uppercase tracking-wide"
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHeader>

      <TableBody className="divide-y border border-gray-200 bg-white">
        {filteredData.map((rep) => (
          <TableRow
            key={rep.id}
            className="hover:bg-gray-100  transition-colors duration-200"
          >
            <TableCell className="py-3 px-2 font-medium text-gray-800  text-center">
              {rep.name}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.city}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.mobileNumber}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.callsInitiated}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.avgResponseSpeedHrs?.toFixed(1) || "0.0"}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.followUpRate}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.rfqResponseSpeedHrs?.toFixed(1) || "0.0"}
            </TableCell>
            <TableCell className="py-3 px-2 text-gray-800  text-center">
              {rep.conversionRate}
            </TableCell>
            <TableCell className="py-3 px-2 text-center">
              <span
                className={`px-3 py-1.5 text-xs font-semibold rounded-full ${
                  statusColorMap[rep.performanceStatus] ||
                  "bg-gray-200 text-gray-800 "
                }`}
              >
                {rep.performanceStatus}
              </span>
            </TableCell>
            <TableCell className="py-3 px-2 text-center">
              <button
                onClick={() => openEditModal(rep)}
                className="p-2 rounded-full bg-gray-200"
                title="Edit"
              >
                <PencilIcon className="h-5 w-5 text-gray-800" />
              </button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>


  {/* Card layout - visible on mobile only */}
<div className="md:hidden overflow-x-auto flex space-x-3 pb-3
  [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
  {filteredData.map((rep) => (
    <div
      key={rep.id}
      className={`flex-shrink-0 rounded-xl shadow-sm border border-gray-200 
                   bg-white  p-3
                  ${filteredData.length === 1 
                    ? "w-full" 
                    : "min-w-[240px] max-w-[240px]"
                  }`}
    >
      {/* Top section: Name + Change button */}
    <div className="flex items-center justify-between mb-2">
  <h3 className="text-base font-semibold text-gray-800  truncate">
    {rep.name}
  </h3>
  <button
    onClick={() => openEditModal(rep)}
    className="inline-flex items-center gap-1 px-3 py-1 rounded-md 
               bg-blue-50 text-blue-600 hover:bg-blue-100 
                text-xs font-medium transition"
  >
    <PencilIcon className="h-4 w-4" />
    Change
  </button>
</div>


      {/* Status */}
      <span
        className={`px-2 py-0.5 rounded-full text-xs font-medium ${
          statusColorMap[rep.performanceStatus] || "bg-gray-300 text-gray-800"
        }`}
      >
        {rep.performanceStatus}
      </span> 

      {/* Stats section */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-sm leading-5 mt-2">
        {rep.city && (
          <p className="text-gray-500  ">📍 {rep.city}</p>
        )}
        {rep.mobileNumber && (
          <p className="text-gray-500  ">📞 {rep.mobileNumber}</p>
        )}
        </div>

        {/* ✅ New fields */}
      {rep.callsInitiated !== undefined && (
  <p className="text-gray-600 text-xs mb-1"> 
    📊 Calls Received: <span className="font-medium">{rep.callsInitiated}</span>
  </p>
)}

{rep.callsResponded !== undefined && (
  <p className="text-gray-600 text-xs mb-1">
    ☎️ Calls Responded:
    <span className="font-medium">
      {rep.callsResponded} ({((rep.callsResponded / rep.callsReceived) * 100).toFixed(0)}%)
    </span>
  </p>
)}

{rep.rfqResponseSpeedHrs !== undefined && (
  <p className="text-gray-600 text-xs mb-1">
    📩 RFQ Received: {rep.rfqResponseSpeedHrs?.toFixed(1) || "0.0"}
  </p>
)}

{rep.rfqResponded !== undefined && (
  <p className="text-gray-600 text-xs mb-1">
    ✅ RFQ Responded:
    <span className="font-medium">
      {rep.rfqResponded} ({((rep.rfqResponded / rep.rfqReceived) * 100).toFixed(0)}%)
    </span>
  </p>
)}

{rep.avgResponseSpeedHrs !== undefined && (
  <p className="col-span-2 text-gray-600 text-xs mb-1"> 
    ⏱ Avg Response Time: {rep.avgResponseSpeedHrs?.toFixed(1) || "0.0"}
  </p>
)}

      {/* Info note */}
      {/* <p className="mt-3 text-xs text-gray-500  italic">
        Company has to call Brickbucket to add Sales Rep.
      </p> */}
    </div>
  ))}     
</div>

  


</div>




      {/* ➕ Add Sales Rep Modal */}
      {showAddModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
          <div className="bg-white/95  p-6 rounded-2xl shadow-2xl w-full max-w-md border border-gray-200 ">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 ">
              Add Sales Rep
            </h2>
            {["name", "mobile", "email", "city", "state", "region"].map(
              (field) => (
                <div key={field} className="mb-3">
                  <label className="block mb-1 text-sm font-medium text-gray-700  capitalize">
                    {field}
                  </label>
                  <input
                    type="text"
                    value={newRep[field]}
                    onChange={(e) =>
                      setNewRep({ ...newRep, [field]: e.target.value })
                    }
                    className="w-full border rounded-lg px-3 py-2 "
                  />
                </div>
              )
            )}
            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setShowAddModal(false)}
                className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800  transition"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveNewRep}
                className="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white shadow-sm transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}


{showFilterModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 p-2 sm:p-2">
    <div className="bg-white  rounded-2xl shadow-2xl w-full max-w-md sm:max-w-xl relative flex flex-col sm:flex-row overflow-hidden">
      
      {/* Close Icon */}
      <XMarkIcon
        className="w-6 h-6 absolute top-4 right-4 cursor-pointer text-gray-500 hover:text-gray-700"
        onClick={() => setShowFilterModal(false)}
      />

      {/* Left Panel: Filter Categories */}
    {/* Left Panel: Filter Categories */}
<div className="w-full sm:w-1/3 px-2 pr-6 py-4 sm:py-6 relative"> 
  <h2 className="text-lg sm:text-base font-semibold mb-4">Filter By</h2>
  <ul className="space-y-2">
    <li
      className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
        selectedFilterCategory === "city"
          ? "bg-blue-100 text-blue-700"
          : "hover:bg-gray-100 "
      }`}
      onClick={() => setSelectedFilterCategory("city")}
    >
      City
    </li>
    <li
      className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
        selectedFilterCategory === "performanceStatus"
          ? "bg-blue-100 text-blue-700"
          : "hover:bg-gray-100 "
      }`}
      onClick={() => setSelectedFilterCategory("performanceStatus")}
    >
      Performance
    </li>
  </ul>

  {/* Vertical Line */}
  <div className="hidden sm:block absolute top-4 bottom-4 right-0 w-px bg-gray-200 "></div>
</div>


      {/* Right Panel: Filter Options */}
      <div className="w-full sm:w-2/3 px-4 py-4 sm:py-6">
        <h3 className="text-md sm:text-base font-semibold mb-4">
          {selectedFilterCategory === "city" ? "Select City" : "Select Performance"}
        </h3>
        <ul className="space-y-2 max-h-64 overflow-y-auto">
          {/* "All" Option */}
          <li
            className="cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100  text-sm sm:text-base"
            onClick={() => {
              setFilters((f) => ({ ...f, [selectedFilterCategory]: "" }));
              setShowFilterModal(false);
            }}
          >
            All
          </li>

          {/* Dynamic Options */}
          {selectedFilterCategory === "city"
            ? [...new Set(salesRepsData.map((r) => r.city).filter(Boolean))].map((city) => (
                <li
                  key={city}
                  className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
                    filters.city === city ? "bg-blue-500 text-white" : "hover:bg-gray-100 "
                  }`}
                  onClick={() => {
                    setFilters((f) => ({ ...f, city }));
                    setShowFilterModal(false);
                  }}
                >
                  {city}
                </li>
              ))
            : [...new Set(salesRepsData.map((r) => r.performanceStatus).filter(Boolean))].map((status) => (
                <li
                  key={status}
                  className={`cursor-pointer px-3 py-2 rounded-lg text-sm sm:text-base ${
                    filters.performanceStatus === status
                      ? "bg-blue-500 text-white"
                      : "hover:bg-gray-100 "
                  }`}
                  onClick={() => {
                    setFilters((f) => ({ ...f, performanceStatus: status }));
                    setShowFilterModal(false);
                  }}
                >
                  {status}
                </li>
              ))}
        </ul>
      </div>
    </div>
  </div>
)}


  



      {/* ✏️ Edit Modal */}
{selectedRep && (
  <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 px-4">
    <div className="bg-white  p-6 rounded-lg shadow-xl w-full max-w-[200px] sm:max-w-xs border border-gray-200 ">
        
      {/* Title */}
      <h2 className="text-sm sm:text-base font-semibold mb-3 px-4 text-gray-800  text-start">
        Edit Sales Rep
      </h2>

      {/* Name Field */}
      <div className="mb-2 sm:mb-3 px-4">
        <label className="block mb-1 text-[11px] sm:text-xs font-medium text-gray-700 ">
          Name
        </label>
        <input
          type="text"
          value={selectedRep.name}
          onChange={(e) =>
            setSelectedRep({ ...selectedRep, name: e.target.value })
          }
          className="w-full border rounded-md px-2.5 py-1.5 text-[13px] sm:text-sm "
        />
      </div>

      {/* Mobile Field */}
      <div className="mb-2 sm:mb-3 px-4">
        <label className="block mb-1 text-[11px] sm:text-xs font-medium text-gray-700 ">
          Mobile Number
        </label>
        <input
          type="text"
          value={selectedRep.mobileNumber || ""}
          onChange={(e) =>
            setSelectedRep({
              ...selectedRep,
              mobileNumber: e.target.value,
            })
          }
          className="w-full border rounded-md px-2.5 py-1.5 text-[13px] sm:text-sm "
        />
      </div>

      {/* Buttons */}
      <div className="flex justify-center gap-3 mt-4">  
        <button
          onClick={closeModal}
          className="px-3 py-1.5 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800  
                     text-[12px] sm:text-sm transition"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white 
                     text-[12px] sm:text-sm shadow-sm transition"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}




    </div>
  );
}
